// JS REFRESH BADGE LIVRAISON (CARTE ET FICHE PRODUIT) SELON PANIER
document.addEventListener('DOMContentLoaded', function () {
  if (!document.querySelector('[data-jinta-shipping-badge]')) return;
  const DEFAULT_FREE_TEXT = window.JINTA_SHIPPING_TEXTS.free;
  const DEFAULT_BEFORE_TEXT = window.JINTA_SHIPPING_TEXTS.before;
  const DEFAULT_AFTER_TEXT = window.JINTA_SHIPPING_TEXTS.after;

  function formatMoney(cents) {
    return (cents / 100)
      .toFixed(2)
      .replace('.', ',')
      .replace(',00', '') + ' €';
  }

  function updateJintaShippingBadges(cartTotal) {
    document.querySelectorAll('[data-jinta-shipping-badge]').forEach(function (badge) {
      const threshold = parseInt(badge.dataset.threshold || '6500', 10);
      const productPrice = parseInt(badge.dataset.productPrice || '0', 10);
      const text = badge.querySelector('[data-jinta-shipping-text]');
      const icon = badge.querySelector('.jinta-free-shipping-badge__icon');

      const freeText = badge.dataset.textFree || DEFAULT_FREE_TEXT;
      const isProductPageBadge = badge.classList.contains('jinta-free-shipping-badge--product');

const beforeText = isProductPageBadge
  ? (badge.dataset.textBefore || DEFAULT_BEFORE_TEXT)
  : '';

const afterText = isProductPageBadge
  ? (badge.dataset.textAfter || DEFAULT_AFTER_TEXT)
  : window.JINTA_SHIPPING_TEXTS.cardAfter;
   

      if (!text) return;

      if (productPrice >= threshold || cartTotal >= threshold) {
      // text.innerHTML = '<strong>' + freeText + '</strong>';
        text.textContent = freeText;
        text.classList.add('is-strong');
        if (icon) icon.style.display = '';
      } else {
        const remaining = Math.max(threshold - cartTotal, 0);
        text.textContent = [beforeText, formatMoney(remaining), afterText].filter(Boolean).join(' ');
        if (icon) icon.style.display = '';
      }
    });
  }

  async function refreshJintaShippingBadges() {
    try {
      const res = await fetch('/cart.js', {
        headers: { Accept: 'application/json' }
      });

      if (!res.ok) return;

      const cart = await res.json();
      updateJintaShippingBadges(cart.total_price || 0);
    } catch (e) {
      console.warn('Erreur refresh badge livraison Jintashop', e);
    }
  }

  //refreshJintaShippingBadges();

if (document.body.classList.contains('template-collection')) {
  runWhenIdle(refreshJintaShippingBadges);
} else {
  refreshJintaShippingBadges();
}

  document.addEventListener('cart:updated', refreshJintaShippingBadges);
  document.addEventListener('cart:refresh', refreshJintaShippingBadges);
  document.addEventListener('product:added', refreshJintaShippingBadges);

  document.addEventListener('click', function (event) {
    const btn = event.target.closest('button[name="add"], .quick-add__submit, .product-form__submit');
    if (!btn) return;

    setTimeout(refreshJintaShippingBadges, 500);
    setTimeout(refreshJintaShippingBadges, 1000);
  });
});